import React from 'react';

import type { FaceId } from '@vlabs/api/luna-api/model';
import { Control, useModal } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { VerifyFaceForm } from './VerifyFaceForm';

interface VerifyFaceButtonProps {
  faceId: FaceId;
  className?: string;
  disabled?: boolean;
}

function VerifyFaceButton({
  faceId,
  className = undefined,
  disabled = false,
}: VerifyFaceButtonProps): JSX.Element {
  const { t } = useTranslation();
  const verifyModal = useModal({ size: 'small' });

  const handleClick = async () => {
    verifyModal.open();
  };

  return (
    <React.Fragment>
      {verifyModal.wrap(<VerifyFaceForm faceId={faceId} />)}
      <Control.Button
        className={className}
        data-testid="verifyButton"
        disabled={disabled}
        kind="secondary"
        onClick={handleClick}
        size="small"
        variant="outlined"
      >
        {t('card-page:features.verify face.verify button.label')}
      </Control.Button>
    </React.Fragment>
  );
}

export { VerifyFaceButton };
